import styled, { css } from 'styled-components';

import { CopyIcon } from '@polyai/ui/components/atoms/Icons';
import {
  Body,
  BodyStrong,
  Caption,
  Title,
} from '@polyai/ui/components/atoms/LegacyText';
import Card from '@polyai/ui/components/molecules/Card';
import { ModalButtons } from '@polyai/ui/components/molecules/LegacyModal';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const Content = styled.div`
  margin: ${themeSpacing.sm4} 0;
`;

export const CardContainer = styled.div`
  display: flex;
  gap: ${themeSpacing.sm1};
`;

export const NumberCard = styled(Card)`
  flex-basis: 50%;
  border: 1px solid ${themeColors.borderSubtle};

  &:hover {
    cursor: pointer;
  }
`;

export const Description = styled(Caption)`
  margin-top: ${themeSpacing.xs2};
`;

export const FakeNumber = styled.span`
  font-weight: ${text.weight.semibold};
  text-wrap: nowrap;
  white-space: nowrap;
`;

export const ModalSubtext = styled(Body)`
  margin-top: ${themeSpacing.sm1};
  margin-bottom: ${themeSpacing.sm4};
  color: ${themeColors.textSecondary};
`;

export const ButtonsGroup = styled(ModalButtons)`
  margin-top: ${themeSpacing.sm4};
`;

export const SupportEmail = styled(BodyStrong)`
  display: inline;
`;

export const TwilioSipCardTitle = styled(Title)`
  margin-bottom: ${themeSpacing.sm1};
`;

export const TwilioSipCard = styled(Card)<{ $hasBorder?: boolean }>`
  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
      border: 1px solid ${themeColors.borderSubtle};
    `}
`;

export const TwilioSipCardHelpLink = styled.a`
  font-weight: ${({ theme }) => theme.text.weight.semibold};
`;

export const TwilioSipCardText = styled(Caption)`
  color: ${themeColors.textSecondary};
`;

export const TwilioSipCardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${themeSpacing.xs1};
  margin-top: ${themeSpacing.sm3};
`;

export const ConnectionTokenWrapper = styled.div<{ $whiteBg?: boolean }>`
  display: flex;
  justify-content: space-between;

  min-height: ${themeSpacing.md2};
  padding: ${themeSpacing.xs3} ${themeSpacing.sm1};

  background: ${({ $whiteBg }) =>
    $whiteBg ? 'white' : themeColors.backgroundAccent};
  border-radius: ${themeSpacing.radiusMedium};

  & h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CopyTokenIcon = styled(CopyIcon)`
  &:hover {
    cursor: pointer;
  }
`;

export const LoadingContainer = styled(Body)`
  display: flex;
  gap: ${themeSpacing.xs1};
  align-items: center;
  color: ${themeColors.textSecondary};
`;
